import { Tabs as OptimusTabs, TabsProps } from '@optimus-web/core';

export const Tabs = (props: TabsProps) => <OptimusTabs {...props} inline showDivider />;
